function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgUsd = function SvgUsd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M244.87,256H512c0-23.106-3.08-45.49-8.819-66.783H244.87V256z"
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M244.87,122.435h229.556c-15.671-25.572-35.708-48.175-59.07-66.783H244.87V122.435z"
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M256,512c60.249,0,115.626-20.824,159.356-55.652H96.644C140.374,491.176,195.751,512,256,512z"
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M37.574,389.565h436.852c12.581-20.529,22.338-42.969,28.755-66.783H8.819 C15.236,346.596,24.993,369.036,37.574,389.565z"
  })), React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M118.584,39.978h23.329l-21.7,15.765l8.289,25.509l-21.699-15.765L85.104,81.252l7.16-22.037 C73.158,75.13,56.412,93.776,42.612,114.552h7.475l-13.813,10.035c-2.152,3.59-4.216,7.237-6.194,10.938l6.596,20.301l-12.306-8.941 c-3.059,6.481-5.857,13.108-8.372,19.873l7.267,22.368h26.822l-21.7,15.765l8.289,25.509l-21.699-15.765l-12.998,9.444 C0.678,234.537,0,245.189,0,256h256c0-141.384,0-158.052,0-256C205.428,0,158.285,14.67,118.584,39.978z M128.502,230.4 l-21.699-15.765L85.104,230.4l8.289-25.509l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822l-21.7,15.765L128.502,230.4z  M120.213,130.317l8.289,25.509l-21.699-15.765l-21.699,15.765l8.289-25.509l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822 L120.213,130.317z M220.328,230.4l-21.699-15.765L176.93,230.4l8.289-25.509l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822 l-21.7,15.765L220.328,230.4z M212.039,130.317l8.289,25.509l-21.699-15.765l-21.699,15.765l8.289-25.509l-21.7-15.765h26.822 l8.288-25.509l8.288,25.509h26.822L212.039,130.317z M212.039,55.743l8.289,25.509l-21.699-15.765L176.93,81.252l8.289-25.509 l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822L212.039,55.743z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUsd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/USD.36ab476e.svg";
export { ForwardRef as ReactComponent };